/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type ISuggestedChangeCreateMutationVariables = Types.Exact<{
  escrowId: Types.Scalars['ID']['input'];
  suggestedChangeParams: Types.ISuggestedChangeParams;
}>;

export type ISuggestedChangeCreateMutation = {
  __typename?: 'Mutation';
  suggestedChangeCreate?: {
    __typename?: 'SuggestedChangeCreatePayload';
    success: boolean;
    errors?: Array<string> | null;
    suggestedChange?: {
      __typename?: 'SuggestChange';
      id: string;
      payload: any;
      partyStatus?: Types.SuggestedChangeStatusEnum | null;
      status: Types.SuggestedChangeStatusEnum;
      creatorType: Types.EscrowPartyTypeEnum;
      receiverType?: Types.EscrowPartyTypeEnum | null;
      policy: { __typename?: 'SuggestedChangePolicy'; review: boolean; update: boolean };
    } | null;
  } | null;
};

export const SuggestedChangeCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'suggestedChangeCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'escrowId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'suggestedChangeParams' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SuggestedChangeParams' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'suggestedChangeCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'escrowId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'escrowId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'suggestedChangeParams' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'suggestedChangeParams' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'suggestedChange' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SuggestChangeFields' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SuggestChangeFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SuggestChange' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payload' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partyStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'creatorType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiverType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'review' } },
                { kind: 'Field', name: { kind: 'Name', value: 'update' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ISuggestedChangeCreateMutation, ISuggestedChangeCreateMutationVariables>;
